export default __webpack_public_path__ + "static/media/cloudy.eceabd1d.jpg";